import { ProcessingActivitiesProgressViewModel } from "../../processingActivity/processingActivities/ProcessingActivities.types";
import { ProcessingActivityCountWigetProps } from "./ProcessingActivityCountWiget";
import { getProcessingActivitiesProgressUrl } from "../../processingActivity/processingActivities/LegacyProcessingActivities.hooks";
import { useUserContext } from "../../auth/userContextProvider/UserContextProvider.tsx";
import { useState } from "react";
import { NavigationMenuItem } from "../../navigationMenuSettings/NavigationMenuSettings.types";
import { isNavigationMenuItemHidden } from "../../navigationMenuSettings/navigationMenuItems";

import { useDotLegalQuery } from "@common/hooks/dotLegalReactQuery";

export function useProcessingActivityCountWidgetProps(props: ProcessingActivityCountWigetProps) {
    const userContext = useUserContext();
    const progreesUrl = getProcessingActivitiesProgressUrl(props.onlyUserSpecific, props.selectedGroupCompany);
    const isEnabled =
        userContext.permissions.processingActivityPermissions.read &&
        !isNavigationMenuItemHidden(userContext.hiddenNavigationMenuItems, NavigationMenuItem.ProcessingActivities);

    let { isLoading, data } = useDotLegalQuery<ProcessingActivitiesProgressViewModel>(progreesUrl, {
        enabled: isEnabled,
    });

    return { isLoading, data, isEnabled };
}
